module.exports = __webpack_public_path__ + "img/logo.c2872c3c.png";